module.exports = __webpack_public_path__ + "facebook.png?5b8b9c0d8b8dbc20c53eed722860f42e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook.png
// module id = 32
// module chunks = 0